import WidgetClassInformationResourceModel from '../../generated/types/model/resource/WidgetClassInformationResourceModel';

export default class WidgetClassInformationResourceViewModel extends WidgetClassInformationResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
